function sanitizeUrl(raw: string | undefined): string | undefined {
    if (!raw) return raw;
    try {
        const url = new URL(raw, 'https://placeholder.invalid');
        url.search = '';
        return url.toString().replace('https://placeholder.invalid', '');
    } catch {
        return raw.split('?')[0];
    }
}

function sanitizeApiUrl(raw: string | undefined): string {
    if (!raw) return '';
    try {
        const url = new URL(raw, 'https://placeholder.invalid');
        url.search = '';
        return url.pathname;
    } catch {
        return raw.split('?')[0];
    }
}

const UUID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const NUMERIC_SEGMENT = /^\d+$/;

// `/patients/12345/timeline` -> `/patients/:id/timeline`; fingerprinting raw paths would
// mint a new Sentry issue per patient instead of one grouped issue.
function normalizeApiPath(path: string): string {
    return path
        .split('/')
        .map((segment) => {
            if (NUMERIC_SEGMENT.test(segment)) return ':id';
            if (UUID_SEGMENT.test(segment)) return ':uuid';
            return segment;
        })
        .join('/');
}

export { sanitizeUrl, sanitizeApiUrl, normalizeApiPath };
